import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { takeUntil } from 'rxjs';
import { BaseEditPopUpComponent } from '../../Services/BaseEditPopUpComponent';
import { ConfigService } from "../../Services/ConfigService";
import { PropertyItemService } from "../../Services/Custom/ServicePropertyItem";

@Component({
	selector: 'PropertyItem-edit',
	templateUrl: 'PropertyItemEdit.html',

})
export class CustomerPropertyItemEditComponent extends BaseEditPopUpComponent {

	constructor(
		public configData: ConfigService,
		private iactiveModal: NgbActiveModal,
		private myPropertyItemService: PropertyItemService,
	) {
		super();

		this.activeModal = iactiveModal;
	}


	myItem = {} as TooBig4Car.Logic.PropertyItemCustomerVM;

	loadItem(item: TooBig4Car.Logic.PropertyItemCustomerVM) {
		this.myItem = item;
	}

	saveItem(form: NgForm) {
		this.isSaving = true;
		this.myPropertyItemService.saveCustomerFields(this.myItem)
			.pipe(takeUntil(this.obsToCloseSubject))
			.subscribe((returnVal) => {
				this.closePopUp(returnVal);
			},
				(error: any) => {
					this.showValidationErrors(error, form);
				});
	}
}
